import { Injectable, inject, DOCUMENT } from '@angular/core';


import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private readonly document = inject(DOCUMENT);

  private currentHeight = 0;

  private postToHost(payload: Record<string, unknown>): void {
    const win = this.document.defaultView;

    if (win && win.top !== win.self) {
      win.top?.postMessage(payload, environment.containerHost);
    }
  }

  handleHeightResize(height: number): void {
    if (this.currentHeight !== height) {
      this.currentHeight = height;
      this.postToHost({ key: 'resize', size: this.currentHeight });
    }
  }

  handleLoaderShow(isShow: boolean): void {
    this.postToHost({ key: 'loader', isShow });
  }

  handleModalShow(isShow: boolean): void {
    this.postToHost({ key: 'modal', isShow });
  }

  removeQueryParam(isPortability: boolean): void {
    this.postToHost({ key: 'isPortability', isPortability });
  }

  handleScrollTop(): void {
    this.postToHost({ key: 'scrollTop' });
  }

  handleNavigation(type: string, url: string): void {
    this.postToHost({ key: 'navigation', type, url });
  }

  sendTags<T = unknown>(type: string, data: T): void {
    this.postToHost({ type, data });
  }
}
